module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button_content"
  }, [_c('el-button', {
    staticClass: "alone_button"
  }, [_vm._v(_vm._s(_vm.text))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-da615a76","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/button/aloneButton.vue
// module id = 604
// module chunks = 1 2 3 4 5 6 7 8